// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k45u1","right":"styles_right__wC_A9"};